import { useQuery } from 'react-query';

import { FREQUENTLY_ORDER_QUERY_KEY } from '~/api/query-keys';

export type { FrequentlyOrderProduct } from '~/api/model';

/** 자주 구매한 상품 목록 조회 */
// GET /api/market-place/v1/frequently-order/products
export const useFrequentlyOrderProducts = () => {
  const { queryKey, queryFn } = FREQUENTLY_ORDER_QUERY_KEY.products();

  return useQuery(queryKey, queryFn, {
    suspense: true,
    keepPreviousData: true,
    // 자주 구매한 상품 목록은 실시간성이 낮다. 프리페치 후 즉시 재요청 방지 (5분)
    staleTime: 5 * 60 * 1000,
  });
};
